import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@speakai/ui/button";
import { useAppStore } from "@/stores";
import { trackFunnel } from "@/lib/integrations/sentry-tracking";
import { FloatingActionCard } from "@/features/meeting-reminders/floating-action-card";

/** Floating notice for an action blocked by credits; Keep going opens the keep-going dialog. */
export function BlockedNoticeCard() {
  const { t } = useTranslation();
  const notice = useAppStore((s) => s.blockedNotice);
  const dismissBlockedNotice = useAppStore((s) => s.dismissBlockedNotice);
  const openSubscriptionGate = useAppStore((s) => s.openSubscriptionGate);

  useEffect(() => {
    if (notice) trackFunnel("paywall", "blocked_notice_view", { source: notice.source });
  }, [notice]);

  if (!notice) return null;

  const handleKeepGoing = () => {
    dismissBlockedNotice();
    openSubscriptionGate({ source: notice.source, onResume: notice.onResume });
  };

  return (
    <FloatingActionCard
      testId="blocked-notice-card"
      title={notice.title}
      subtitle={notice.message}
      onDismiss={dismissBlockedNotice}
      action={
        <Button type="button" size="sm" onClick={handleKeepGoing}>
          {t("PAYWALL.KEEP_GOING.CTA", "Keep going")}
        </Button>
      }
    />
  );
}
